import { useParams } from 'react-router-dom'
import {
  VolumeData,
  VolumeParams,
} from 'Features/VolumeChart/VolumeChart.types'
import { useState, useEffect } from 'react'
import { Loader } from 'Common/Loader/Loader'
import { VolumeGraph } from 'Features/VolumeChart/VolumeChart.graph'
import { Box } from '@mui/material'
import { useSourceSiteVolumeData } from './SourceSiteDashboard.data'
import { formatDateWithHiphen } from 'Common/utils/utils'

type VolumeChartViewProps = {
  workcentresList: string[]
}
export const VolumeChartView = ({ workcentresList }: VolumeChartViewProps) => {
  const { planId } = useParams<VolumeParams>()

  const [volumeData, setVolumeData] = useState<VolumeData | undefined>(
    undefined
  )

  const { data, isLoading: isVolumeDataLoading } = useSourceSiteVolumeData({
    planId: planId ?? '',
    workcentresList,
  })

  useEffect(() => {
    setVolumeData(data)
  }, [data])

  if (isVolumeDataLoading) {
    return <Loader />
  }

  return (
    <Box display="flex" flexDirection="column" sx={{ cursor: 'pointer' }}>
      <VolumeGraph
        xAxisData={volumeData?.productionDate?.map(formatDateWithHiphen) ?? []}
        unconstrainedVolume={volumeData?.unconstrainedVolume ?? []}
        conLtUncon={volumeData?.conLtUncon ?? []}
        conGrtUncon={volumeData?.conGrtUncon ?? []}
        conEqUncon={volumeData?.conEqUncon ?? []}
      />
    </Box>
  )
}
